export function initDataPaste() {

    document.body.addEventListener("paste", handlePaste);

    function handlePaste(e) {
        // Get pasted text
        let pastedText = e.clipboardData.getData("text").trim();
        let lines = pastedText.split(/\r?\n/); // Split by new lines

        // Find the parent <td>
        let cell = e.target.closest("td");
        if (!cell) return;

        // Find the parent <tr> and its index
        let row = cell.closest("tr");
        if (!row) return;

        let table = row.closest("table");
        if (!table) return;

        e.preventDefault();

        let cellIndex = Array.from(row.children).indexOf(cell); // Get <td> position in row
        
        let rows = table.querySelectorAll("tr");
        let rowIndex = Array.from(rows).indexOf(row);

        // Walk down the table and at each corresponding td > input, paste the next line
        lines.forEach((line, rowOffset) => {
            let targetRow = rows[rowIndex + rowOffset]; // Get next row
            if (!targetRow) return; // Stop if out of bounds

            let targetCell = targetRow.children[cellIndex]; // Get corresponding column <td>
            if (!targetCell) return;

            let input = targetCell.querySelector("input");
            if (input){
                input.value = line; // Paste text into input
                input.dispatchEvent(new Event("input", { bubbles: true }));
            };
        })
    }
};